var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"vimeo",staticClass:"vimeo-player",attrs:{"src":("https://player.vimeo.com/video/" + _vm.vimeoId + "?autoplay=1"),"frameborder":"0","allow":"autoplay; fullscreen","allowfullscreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }